import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  SectionContextProvider,
  EditableToken,
} from '@vibesites/runtime/react';

// ============================================================================
// Component
// ============================================================================

export function InteractiveMapSection() {
  const mapSlot = useBlockSlot('interactivemapsection.map_block', {
    defaultValue: 'apartment-sync-map',
  });

  return (
    <section className="interactive-map-section">
      <EditableToken path="interactivemapsection.map_block" as="div">
        {mapSlot ? (
          <SectionContextProvider sectionId={mapSlot.sectionId}>
            <mapSlot.BlockComponent sectionId={mapSlot.sectionId} />
          </SectionContextProvider>
        ) : (
          <div>No block selected</div>
        )}
      </EditableToken>

      {/*
        STOPGAP for a core-block gap in @vibesites/blocks useRRACScript
        (RRAC_STYLE_OVERRIDES): the ApartmentSync/Repli360 (RRAC) script
        appends its modal/popup shells — the "Select Desired Move In Date"
        date picker, the "Lease Now" button, the "X" close buttons — directly
        to <body>. The core hook removes them on teardown (see
        RRAC_BODY_HELPER_SELECTORS = ['.rrac-popup', '.rrac_modal_container'])
        but never hides them during the async load window, so they flash inline
        at the top of the page, unstyled and dark-on-dark on this theme.

        We hide those body-level shells by default WITHOUT !important. RRAC is a
        jQuery widget (it loads jQuery 1.11.3 and binds init to
        jQuery(window).on('load')); when a unit is clicked it opens a popup via
        jQuery .show()/.fadeIn(), which sets an INLINE display — inline styles
        beat this stylesheet rule, so the popups still open normally. The proper
        fix belongs in the core hook; remove this once that lands.
      */}
      <style>{`
        body > .rrac-popup,
        body > .rrac_modal_container {
          display: none;
        }
        .interactive-map-section {
          width: 100%;
        }
      `}</style>
    </section>
  );
}

// ============================================================================
// Schema
// ============================================================================

export const contentSchema: ComponentContentSchema = {
  slot: 'InteractiveMapSection',
  displayName: 'Interactive Map Section',
  tokens: {
    'interactivemapsection.map_block': {
      label: 'Map Block',
      type: 'block',
      defaultValue: 'apartment-sync-map',
      acceptedBlockCategories: ['Integrations'],
    },
  },
  slotGroups: {},
  collectionBindings: {},
};

(InteractiveMapSection as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default InteractiveMapSection;
